import { fetchJSON, stringifyParams } from 'utils/req'

export const createPerformanceReview = <T>(
  performanceReview: Partial<T>,
  params: unknown
) =>
  fetchJSON<T>(
    `/api/v1/performance_reviews?${stringifyParams(params)}`,
    'POST',
    { performance_review: performanceReview },
    {
      useJwt: true,
    }
  )

export const fetchPerformanceReviews = <T>(params: unknown) =>
  fetchJSON<T>(
    `/api/v1/performance_reviews?${stringifyParams(params)}`,
    'GET',
    null,
    {
      useJwt: true,
    }
  )

export const fetchPerformanceReview = <T>(id: number, params: unknown) =>
  fetchJSON<T>(
    `/api/v1/performance_reviews/${id}?${stringifyParams(params)}`,
    'GET',
    null,
    {
      useJwt: true,
    }
  )

export const putPerformanceReview = <T, AT>(
  id: number,
  params: unknown,
  attributes: AT
) =>
  fetchJSON<T>(
    `/api/v1/performance_reviews/${id}?${stringifyParams(params)}`,
    'put',
    { performance_review: attributes },
    {
      useJwt: true,
    }
  )
